// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"4ed60b46","703":"0d5bed62","787":"c5066a96"}[chunkId] + ".chunk.js";
};